const resource = {
    resource_identifier_in_use: 'Идентификатор API {{indicator}} уже используется',
    cannot_delete_management_api: 'Не удается удалить управляемый API Logto.',
    cannot_modify_management_api: 'Не удается изменить управляемый API Logto.',
};
export default Object.freeze(resource);
